/**
 * The invitation text, in the recipient's language. Shared by the admin screen (copy/share) and the
 * server (the invitation e-mail), so both say exactly the same.
 */
export type InviteLang = 'zh-Hans' | 'sv-SE' | 'en';
export const INVITE_LANGS: readonly InviteLang[] = ['zh-Hans', 'sv-SE', 'en'];

export function inviteText(lang: InviteLang, v: { sender: string; org: string; url: string; hours: number }): string {
  if (lang === 'zh-Hans')
    return `${v.sender} 邀请您加入 ${v.org} 的翻译聊天。每个人都用自己的语言读写，消息会自动翻译。\n请点击链接注册，然后选择您的母语「简体中文」：\n${v.url}\n（链接 ${v.hours} 小时内有效，只能使用一次。）`;
  if (lang === 'sv-SE')
    return `${v.sender} bjuder in dig till översättningschatten hos ${v.org}. Alla skriver och läser på sitt eget språk – meddelandena översätts automatiskt.\nKlicka på länken, registrera dig och välj ditt modersmål:\n${v.url}\n(Länken gäller i ${v.hours} timmar och kan bara användas en gång.)`;
  return `${v.sender} invites you to the translation chat of ${v.org}. Everyone reads and writes in their own language – messages are translated automatically.\nOpen the link, sign up and choose your native language:\n${v.url}\n(The link is valid for ${v.hours} hours and can be used once.)`;
}

export function inviteSubject(lang: InviteLang, v: { sender: string; org: string }): string {
  if (lang === 'zh-Hans') return `${v.sender} 邀请您加入 ${v.org} 的 T-Lián 翻译聊天`;
  if (lang === 'sv-SE') return `${v.sender} bjuder in dig till T-Lián hos ${v.org}`;
  return `${v.sender} invites you to T-Lián at ${v.org}`;
}
